import { Box, Typography } from '@mui/material';
import useStylesEnvironmentBanner from './styles/useStylesEnvironmentBanner.styles';

const EnvironmentBanner = () => {
    const { classes, cx } = useStylesEnvironmentBanner();

    const getEnvironment = () => {
        const hostname = window.location.hostname;

        if (
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            process.env.REACT_APP_ENVIRONMENT === 'development'
        ) {
            return 'development';
        }

        if (hostname.includes('testcms') || process.env.REACT_APP_ENVIRONMENT === 'staging') {
            return 'staging';
        }

        return null;
    };

    const environment = getEnvironment();

    if (!environment) {
        return null;
    }

    const getText = () => {
        switch (environment) {
            case 'staging':
                return 'Staging Environment';
            case 'development':
                return 'Development Environment';
            default:
                return '';
        }
    };

    return (
        <Box
            className={cx(
                classes.banner,
                environment === 'staging' && classes.staging,
                environment === 'development' && classes.development,
            )}
        >
            <Typography className={classes.text} variant="body2">
                {getText()}
            </Typography>
        </Box>
    );
};

export default EnvironmentBanner;
